import classNames from 'classnames/bind'

const Loader = ({ type, size, color, message, showDefaultMessage, style, ...props }) => (
  <div
    className={
      classNames({
        'ma-loader': true,
        [`ma-loader--${type}`]: type,
        [`ma-loader--${size}`]: size,
        [`ma-loader--${color}`]: color,
        [props.className]: props.className
      })
    }
    style={style}
  >
    <div className='ma-loader__inner'>
      <span className='ma-loader__spinner' />
      {
        message && <span className='ma-loader__message'>{message}</span>
      }
      {
        showDefaultMessage && !message &&
        <span className='ma-loader__message'>
          {'Loading'}
        </span>
      }
    </div>
  </div>
)

// Loader.propTypes = {
//   ...intlShape,
//   style: PropTypes.shape({}),
//   message: PropTypes.string,
//   type: PropTypes.oneOf(['absolute', 'inline', 'block']),
//   size: PropTypes.oneOf(['default', 'small', 'middle']),
//   color: PropTypes.oneOf(['red', 'black', 'white']),
//   showDefaultMessage: PropTypes.bool
// }

Loader.defaultProps = {
  message: '',
  type: 'block',
  size: 'default',
  color: 'white',
  showDefaultMessage: false
}

export default Loader



// WEBPACK FOOTER //
// ./components/uiLib/Loader/index.js